import getCorePopUpStore from "../../../../stores/core/core-popup-store";
import Et3Button from "../../../et3-button";
import ET3Div from "../../../et3-div";
import { withLiteObserverAndTheme } from "../../../et3-enhanced-render";

const OKPopUpBottun = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors } = theme;

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      fDirection="row"
      justifyContent="center"
      alignItems="center"
      withShadow={true}
      width={1000}
      height={105}
      color={colors.all.transparent}
      style={{}}
      onClick={() => {}}
    >
      <Et3Button
        isEnabled={true}
        onClick={() => {
          getCorePopUpStore().closePopUps();
        }}
        type="GET"
        size="LARGE"
        text="OK"
      />
    </ET3Div>
  );
});

export default OKPopUpBottun;
